<template>
  <div class="dd-mainpic-container">
    <div
      class="mian-pic"
      v-bind:style="{ backgroundImage: `url(${skuImg})` }"
    ></div>
    <span class="fixed-box">图片仅供参考，请以实物为准</span>
  </div>
</template>
<script>
export default {
  props: {
    skuImg: {
      type: String,
      default: ""
    },
    showType: {
      type: String,
      default: "normalNew"
    }
  },
  computed: {
    imgInfo() {
      return {
        "background-image": this.skuImg
      };
    }
  }
};
</script>
<style lang="less">
.dd-mainpic-container {
  height: 300px;
  background: #fff;
  overflow: hidden;
  position: relative;
  background-image: url("../assets/pic-placeholder.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%;
  h3 {
    text-align: center;
  }
  .mian-pic {
    display: inline-block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .fixed-box {
    position: absolute;
    right: 10px;
    bottom: 10px;
    display: inline-block;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 7px;
    padding: 1px 7px;
    font-size: 9px;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
